import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../reminder_evaluation_event_partner_complete';

export default function Launcher(props) {
  const config = useDialogConfig();

  const evaluationEventPartner = useConnect('evaluationEventPartner.byId', {
    id: config.params.evaluationEventPartnerId
  });

  if (evaluationEventPartner.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      evaluationEventPartner={evaluationEventPartner}
      onClose={props.onClose}
    />
  );
};
